import { Box, List, ListItem, ListItemText } from '@mui/material'
import React from 'react'
import CustomTypography from './CustomTypography'

const MergedTablesPopover = ({ tableData, type,  }) => {
    return (
        <Box>
            {type == "notes" ?
                <>
                    {!tableData?.merged ? (
                        <CustomTypography
                            label={tableData?.notes}
                            variant="subtitle1"
                            sx={{ fontWeight: 400, mb: 0 }}
                        />
                    ) : (
                        <>
                            {/* Parent table notes (if present) */}
                            {tableData?.notes && (
                                <>
                                    <CustomTypography
                                        label={tableData?.table_no}
                                        variant="subtitle1"
                                        sx={{ fontWeight: 400, textDecoration: "underline", mb: 0 }}
                                    />
                                    <CustomTypography
                                        label={tableData?.notes}
                                        variant="subtitle1"
                                        sx={{ fontWeight: 400, mb: 0 }}
                                    />
                                </>
                            )}

                            {/* Child tables with notes */}
                            {tableData?.children?.map((ele) => (
                                ele?.notes ? (
                                    <React.Fragment key={ele?.id}>
                                        <CustomTypography
                                            label={ele?.table_no}
                                            variant="subtitle1"
                                            sx={{ fontWeight: 400, textDecoration: "underline", mb: 0 }}
                                        />
                                        <CustomTypography
                                            label={ele?.notes}
                                            variant="subtitle1"
                                            sx={{ fontWeight: 400, mb: 0 }}
                                        />
                                    </React.Fragment>
                                ) : null
                            ))}
                        </>
                    )}

                </>
                :
                type == "info" && tableData?.reservation ? (
                    <>
                        <CustomTypography
                            label={`Name: ${tableData?.reservation?.customer?.customer_full_name || "-"}`}
                            variant="subtitle1"
                            sx={{ fontWeight: 400, mb: 0 }}
                        />
                        <CustomTypography
                            label={`Number: ${tableData?.reservation?.customer?.customerDetailsInfo?.country_code || "-"}${tableData?.reservation?.customer?.customerDetailsInfo?.phone || "-"}`}
                            variant="subtitle1"
                            sx={{ fontWeight: 400, mb: 0 }}
                        />
                        <CustomTypography
                            label={`Persons: ${tableData?.reservation?.guest_count || "-"}`}
                            variant="subtitle1"
                            sx={{ fontWeight: 400, mb: 0 }}
                        />
                        <CustomTypography
                            label={`From: ${
                                tableData?.reservation?.reserved_from
                                    ? new Date(tableData.reservation.reserved_from).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })
                                    : "-"
                            }`}
                            variant="subtitle1"
                            sx={{ fontWeight: 400, mb: 0 }}
                        />
                        <CustomTypography
                            label={`Until: ${
                                tableData?.reservation?.manual_release
                                    ? "Manual Release"
                                    : tableData?.reservation?.reserved_till
                                    ? new Date(tableData.reservation.reserved_till).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })
                                    : "-"
                            }`}
                            variant="subtitle1"
                            sx={{ fontWeight: 400, mb: 0 }}
                        />
                    </>
                ) :
                <>
                    <CustomTypography
                        label={tableData?.table_no}
                        variant={"subtitle1"}
                        sx={{ fontWeight: 400, textDecoration: "underline", mb: 0 }}
                    />
                    <CustomTypography
                        label={"Merged with"}
                        variant={"subtitle1"}
                        sx={{ fontWeight: 400, mb: 0 }}
                    />

                    <List dense sx={{ m: 0, p: 0, listStyleType: 'disc', pl: 2 }}>
                        {tableData?.children?.map((child) => (
                            <ListItem
                                key={child?.id}
                                sx={{ p: 0, display: "list-item", listStyleType: 'disc' }}
                            >
                                <ListItemText
                                    primaryTypographyProps={{ variant: "body2" }}
                                    primary={child?.table_no}
                                />
                            </ListItem>
                        ))}
                    </List>
                </>
            }
        </Box>
    )
}

export default MergedTablesPopover
